import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { company } = stateEnum

const initialState = {
  compCode: [],
  compName: [],
  startDate: "",
  endDate: "",
  compState: "",
  address: "",
  gstNo:"",
  panNo:"",
  yearId: "",
  appType: "",
  groupCode: "",
  isMultipleCompany: false,
  isReload: false,
  objCompanies: [],
  objAcYear: []
}


const companySlice = createSlice({
  name: company,
  initialState,
  reducers: {
    resetCompCode: (state) => {
      state.compCode = []
      state.compName = []
      state.startDate = ""
      state.endDate = ""
      state.compState = ""
      state.yearId = ""
      state.appType = ""
      state.groupCode = ""
      state.address = ""
      state.panNo = ""
      state.gstNo = ""
      state.isMultipleCompany = false
      state.objCompanies = []
    },
    resetComapanyState: (state) => {
    },
    setAppType: (state, action) => {
      state.appType = action.payload
    },
    setReload: (state, action) => {
      state.isReload = action.payload
    },
    setCompInfo: (state, action) => {

      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.compState = action.payload.state
      state.yearId = action.payload.yearId;
      state.groupCode = action.payload.groupCode;
      state.address = action.payload.address
      state.panNo = action.payload.panNo
      state.gstNo = action.payload.gstNo
      state.objCompanies = action.payload.objComp
      // state.objAcYear=action.payload.objYear
    },
    setCompCode: (state, action) => {
      if (action.payload.compCode.length > 1)
        state.isMultipleCompany = true;
      else
        state.isMultipleCompany = false;
      state.compCode = action.payload.compCode
      state.compName = action.payload.compName

    },
    setYearId: (state, action) => {
      state.yearId = action.payload

    },
    setAcYearData: (state, action) => {
      state.objAcYear = action.payload

    }
  },
})

export const { setCompCode, resetCompCode, setCompInfo, setAppType, setReload, setYearId, setAcYearData } = companySlice.actions
export default companySlice.reducer
